import { useNotification } from '~/shared/hooks/useNotification/useNotification';

import { Notification } from './components/Notification';
import styles from './notifications.module.css';

/**
 * Displays UI based on notification state
 * can be used in root or a scoped location
 *
 */
export const Notifications = () => {
	const { notifications, dismiss } = useNotification();

	if (!notifications.length) {
		return null;
	}

	return (
		<ul
			className={styles.root}
			aria-live="polite"
		>
			{notifications.map((props) => (
				<li key={props.id}>
					<Notification
						onDismiss={() => dismiss(props.id)}
						{...props}
					/>
				</li>
			))}
		</ul>
	);
};
